export class TrackHelper {
    /// <summary>
    /// Start tracking the duration of a process
    /// </summary>
    /// <param name="key">The key to identify the process</param>
    startTracking(key) {
        performance.clearMarks(`${key}-start`);
        performance.clearMarks(`${key}-end`);
        // Mark the start time before the delay
        performance.mark(`${key}-start`);
    }
    /// <summary>
    /// End tracking the duration of a process
    /// </summary>
    /// <param name="key">The key to identify the process</param>
    endTracking(key) {
        // Mark the end time
        performance.mark(`${key}-end`);
        // Measure the difference between the start and end time
        performance.measure(key, `${key}-start`, `${key}-end`);
        // Get the duration of the measure
        const measure = performance.getEntriesByName(key)[0];
        // Log the duration
        console.log(`${key} duration: ${measure.duration}`);
    }
}
